// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.socias-page-wrapper {
    width: 100%;
    min-height: calc(100vh - 70px);
    background-color: var(--bg-app);
    padding: 30px 20px;
}

.socias-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.socias-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.socias-title h1 {
    font-size: 2rem;
    font-weight: 800;
    color: var(--brand-primary);
    margin: 0;
    letter-spacing: -0.5px;
}

.total-badge {
    background-color: var(--bg-card);
    border: 1px solid var(--border-light);
    color: var(--text-muted);
    font-weight: 600;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    box-shadow: var(--shadow-sm);
}

.filters-bar {
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--border-light);
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
}

.filter-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.filter-group label {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--text-muted);
    text-transform: uppercase;
}

.filter-input, .filter-select {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--border-light);
    border-radius: var(--radius-md);
    background-color: var(--bg-app);
    font-size: 0.95rem;
    color: var(--text-main);
    transition: var(--transition);
    box-sizing: border-box;
}

.filter-input:focus, .filter-select:focus {
    outline: none;
    border-color: var(--brand-primary);
    background-color: #fff;
    box-shadow: var(--shadow-input-focus);
}

.players-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
}

.player-card {
    background-color: var(--bg-card);
    border-radius: var(--radius-lg);
    border: 1px solid var(--border-light);
    box-shadow: var(--shadow-sm);
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    transition: transform 0.2s, box-shadow 0.2s;
    position: relative;
}

.player-card:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-card);
    border-color: var(--brand-primary);
}

.card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.player-identity {
    display: flex;
    align-items: center;
    gap: 12px;
}

.avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: var(--brand-accent);
    color: var(--brand-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 1rem;
    flex-shrink: 0;
}

.player-info h3 {
    margin: 0;
    font-size: 1.1rem;
    color: var(--text-main);
    font-weight: 700;
}

.member-number {
    font-size: 0.8rem;
    color: var(--text-muted);
    font-weight: 500;
}

.btn-delete-icon {
    background: transparent;
    border: none;
    color: #cbd5e1;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: color 0.2s;
}

.btn-delete-icon:hover {
    color: #EF4444;
    background-color: #FEF2F2;
}

.info-section {
    background-color: var(--bg-app);
    padding: 12px;
    border-radius: var(--radius-md);
}

.section-label {
    font-size: 0.75rem;
    text-transform: uppercase;
    color: var(--text-muted);
    font-weight: 700;
    margin-bottom: 8px;
    display: block;
}

.level-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.level-value {
    font-size: 1.2rem;
    font-weight: 800;
    color: var(--brand-primary);
}

.btn-edit-icon {
    background: transparent;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    font-size: 0.9rem;
}

.btn-edit-icon:hover {
    color: var(--brand-primary);
}

.level-editor {
    display: flex;
    gap: 8px;
}

.level-input {
    width: 60px;
    padding: 4px 8px;
    border: 1px solid var(--brand-primary);
    border-radius: 6px;
    font-weight: 700;
    text-align: center;
}

.btn-mini {
    background: white;
    border: 1px solid var(--border-light);
    border-radius: 6px;
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-mini.save { color: #10B981; border-color: #10B981; }
.btn-mini.cancel { color: #EF4444; border-color: #EF4444; }

.contact-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.contact-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.85rem;
    color: var(--text-secondary);
}

.contact-item i {
    width: 16px;
    text-align: center;
    opacity: 0.6;
}

.toast-notification {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: var(--brand-primary);
    color: white;
    padding: 12px 24px;
    border-radius: 30px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
    z-index: 3000;
    font-weight: 600;
    font-size: 0.9rem;
    animation: slideUpToast 0.3s ease-out;
}

.toast-notification.error { background-color: #EF4444; }
.toast-notification.success { background-color: #10B981; }

@keyframes slideUpToast {
    from { transform: translate(-50%, 20px); opacity: 0; }
    to { transform: translate(-50%, 0); opacity: 1; }
}

.modal-backdrop {
    position: fixed;
    top: 0; left: 0; width: 100%; height: 100%;
    background: rgba(0,0,0,0.5);
    backdrop-filter: blur(4px);
    display: flex; justify-content: center; align-items: center;
    z-index: 2000;
}

.modal-content {
    background: white;
    padding: 24px;
    border-radius: var(--radius-lg);
    width: 90%; max-width: 400px;
    box-shadow: var(--shadow-card);
    text-align: center;
}

.modal-actions {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 20px;
}

.btn-modal {
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    border: none;
}

.btn-modal.cancel { background: var(--bg-app); color: var(--text-main); }
.btn-modal.danger { background: #EF4444; color: white; }

.loading-state, .empty-state {
    text-align: center;
    padding: 60px 0;
    color: var(--text-muted);
}
.spinner {
    width: 40px; height: 40px; border: 4px solid rgba(0,0,0,0.1);
    border-top-color: var(--brand-accent); border-radius: 50%;
    animation: spin 1s linear infinite; margin: 0 auto 20px auto;
}

@keyframes spin { to { transform: rotate(360deg); } }
`, "",{"version":3,"sources":["webpack://./src/pages/Socias.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,4BAA4B;IAC5B,qCAAqC;IACrC,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,+BAA+B;IAC/B,+BAA+B;IAC/B,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,qCAAqC;IACrC,4BAA4B;IAC5B,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,iBAAiB,cAAc,EAAE,qBAAqB,EAAE;AACxD,mBAAmB,cAAc,EAAE,qBAAqB,EAAE;;AAE1D;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,sCAAsC;IACtC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA,4BAA4B,yBAAyB,EAAE;AACvD,8BAA8B,yBAAyB,EAAE;;AAEzD;IACI,OAAO,gCAAgC,EAAE,UAAU,EAAE;IACrD,KAAK,6BAA6B,EAAE,UAAU,EAAE;AACpD;;AAEA;IACI,eAAe;IACf,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY;IAC1C,2BAA2B;IAC3B,0BAA0B;IAC1B,aAAa,EAAE,uBAAuB,EAAE,mBAAmB;IAC3D,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,+BAA+B;IAC/B,UAAU,EAAE,gBAAgB;IAC5B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA,oBAAoB,yBAAyB,EAAE,uBAAuB,EAAE;AACxE,oBAAoB,mBAAmB,EAAE,YAAY,EAAE;;AAEvD;IACI,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,WAAW,EAAE,YAAY,EAAE,iCAAiC;IAC5D,qCAAqC,EAAE,kBAAkB;IACzD,kCAAkC,EAAE,wBAAwB;AAChE;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE","sourcesContent":[".socias-page-wrapper {\n    width: 100%;\n    min-height: calc(100vh - 70px);\n    background-color: var(--bg-app);\n    padding: 30px 20px;\n}\n\n.socias-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.socias-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 16px;\n}\n\n.socias-title h1 {\n    font-size: 2rem;\n    font-weight: 800;\n    color: var(--brand-primary);\n    margin: 0;\n    letter-spacing: -0.5px;\n}\n\n.total-badge {\n    background-color: var(--bg-card);\n    border: 1px solid var(--border-light);\n    color: var(--text-muted);\n    font-weight: 600;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 0.85rem;\n    box-shadow: var(--shadow-sm);\n}\n\n.filters-bar {\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-sm);\n    border: 1px solid var(--border-light);\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n}\n\n.filter-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.filter-group label {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: var(--text-muted);\n    text-transform: uppercase;\n}\n\n.filter-input, .filter-select {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-md);\n    background-color: var(--bg-app);\n    font-size: 0.95rem;\n    color: var(--text-main);\n    transition: var(--transition);\n    box-sizing: border-box;\n}\n\n.filter-input:focus, .filter-select:focus {\n    outline: none;\n    border-color: var(--brand-primary);\n    background-color: #fff;\n    box-shadow: var(--shadow-input-focus);\n}\n\n.players-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n}\n\n.player-card {\n    background-color: var(--bg-card);\n    border-radius: var(--radius-lg);\n    border: 1px solid var(--border-light);\n    box-shadow: var(--shadow-sm);\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    transition: transform 0.2s, box-shadow 0.2s;\n    position: relative;\n}\n\n.player-card:hover {\n    transform: translateY(-4px);\n    box-shadow: var(--shadow-card);\n    border-color: var(--brand-primary);\n}\n\n.card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.player-identity {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.avatar {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background-color: var(--brand-accent);\n    color: var(--brand-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 1rem;\n    flex-shrink: 0;\n}\n\n.player-info h3 {\n    margin: 0;\n    font-size: 1.1rem;\n    color: var(--text-main);\n    font-weight: 700;\n}\n\n.member-number {\n    font-size: 0.8rem;\n    color: var(--text-muted);\n    font-weight: 500;\n}\n\n.btn-delete-icon {\n    background: transparent;\n    border: none;\n    color: #cbd5e1;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 4px;\n    transition: color 0.2s;\n}\n\n.btn-delete-icon:hover {\n    color: #EF4444;\n    background-color: #FEF2F2;\n}\n\n.info-section {\n    background-color: var(--bg-app);\n    padding: 12px;\n    border-radius: var(--radius-md);\n}\n\n.section-label {\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    color: var(--text-muted);\n    font-weight: 700;\n    margin-bottom: 8px;\n    display: block;\n}\n\n.level-display {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.level-value {\n    font-size: 1.2rem;\n    font-weight: 800;\n    color: var(--brand-primary);\n}\n\n.btn-edit-icon {\n    background: transparent;\n    border: none;\n    color: var(--text-muted);\n    cursor: pointer;\n    font-size: 0.9rem;\n}\n\n.btn-edit-icon:hover {\n    color: var(--brand-primary);\n}\n\n.level-editor {\n    display: flex;\n    gap: 8px;\n}\n\n.level-input {\n    width: 60px;\n    padding: 4px 8px;\n    border: 1px solid var(--brand-primary);\n    border-radius: 6px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.btn-mini {\n    background: white;\n    border: 1px solid var(--border-light);\n    border-radius: 6px;\n    cursor: pointer;\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn-mini.save { color: #10B981; border-color: #10B981; }\n.btn-mini.cancel { color: #EF4444; border-color: #EF4444; }\n\n.contact-list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.contact-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.85rem;\n    color: var(--text-secondary);\n}\n\n.contact-item i {\n    width: 16px;\n    text-align: center;\n    opacity: 0.6;\n}\n\n.toast-notification {\n    position: fixed;\n    bottom: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: var(--brand-primary);\n    color: white;\n    padding: 12px 24px;\n    border-radius: 30px;\n    box-shadow: 0 10px 25px rgba(0,0,0,0.2);\n    z-index: 3000;\n    font-weight: 600;\n    font-size: 0.9rem;\n    animation: slideUpToast 0.3s ease-out;\n}\n\n.toast-notification.error { background-color: #EF4444; }\n.toast-notification.success { background-color: #10B981; }\n\n@keyframes slideUpToast {\n    from { transform: translate(-50%, 20px); opacity: 0; }\n    to { transform: translate(-50%, 0); opacity: 1; }\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0; left: 0; width: 100%; height: 100%;\n    background: rgba(0,0,0,0.5);\n    backdrop-filter: blur(4px);\n    display: flex; justify-content: center; align-items: center;\n    z-index: 2000;\n}\n\n.modal-content {\n    background: white;\n    padding: 24px;\n    border-radius: var(--radius-lg);\n    width: 90%; max-width: 400px;\n    box-shadow: var(--shadow-card);\n    text-align: center;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    margin-top: 20px;\n}\n\n.btn-modal {\n    padding: 10px 20px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n}\n\n.btn-modal.cancel { background: var(--bg-app); color: var(--text-main); }\n.btn-modal.danger { background: #EF4444; color: white; }\n\n.loading-state, .empty-state {\n    text-align: center;\n    padding: 60px 0;\n    color: var(--text-muted);\n}\n.spinner {\n    width: 40px; height: 40px; border: 4px solid rgba(0,0,0,0.1);\n    border-top-color: var(--brand-accent); border-radius: 50%;\n    animation: spin 1s linear infinite; margin: 0 auto 20px auto;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
